import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(() => ({
  loading: {
    padding: '60px 0',
  },
}))

const FormSubmit = ({
  contrast,
  postRoute,
  postData,
  doSubmit,
  onSuccess,
  onFail = () => null,
  height,
  noThanks,
  thanks,
}) => {
  const classes = useStyles()
  const [submitted, setSubmitted] = useState(false)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    if (doSubmit === true) {
      onSubmit()
    }
  }, [doSubmit])

  const onSubmit = () => {
    setSubmitted(true)
    axios.post(postRoute, postData).then((res) => {
      if (res.status === 200) {
        setTimeout(() => {
          setSuccess(true)
        }, 1000)
        setTimeout(() => onSuccess(res.data), 2000)
      } else onFail()
    })
  }

  return (
    <div style={{ minHeight: height, textAlign: 'center', width: '100%' }}>
      {submitted && !success && (
        <div className={classes.loading}>
          <CircularProgress color={contrast ? 'secondary' : 'primary'} />
        </div>
      )}
      {success && !noThanks && (
        <div className={classes.loading}>
          <Typography variant="h3" color={contrast ? 'initial' : 'primary'}>
            {thanks || 'Thanks!'}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default FormSubmit
